import { RolesSelectOptionModel } from "model/RolesSelectOption.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = RolesSelectOptionModel[];

export const useDefaultObservableRolesSelectOptionModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectRolesSelectOptionModelArray extends BehaviorSubject<CurrentType> {}
